(function() {

var _ = ui._;
ui.formOnBlur    = formOnBlur;
ui.formOnInput   = formOnInput;
ui.galleryClick       = galleryClick;
ui.imageShow          = imageShow;
ui.productGalleryPrev = productGalleryPrev;
ui.productGalleryNext = productGalleryNext;
ui.productSet         = productSet;
ui.ratingChange       = ratingChange;
ui.reviewAdd          = reviewAdd;
ui.shareModal         = shareModal;
ui.youtubeShow        = youtubeShow;

var addToCartHE, addToCartLeft, addToCartTop, product, isTouch = 'ontouchstart' in w, touchCount = 0;
var productImages;
var $img, $imgBox, imgBoxRect;
var gallerySwiper, galleryIndex = 0;
var imageScaleStarted = false;
var load_count = 0;
_(d.body).toggleClass('product-page', true);
ui.loadAdd(onLoad);

function productSet(product_id) {
  if(!w.product_data || !ui.productGet) {
    if(load_count < 10)
      setTimeout(productSet, 16, product_id);
    load_count++
    return;
  }

  product = ui.productGet(product_id);
  if(product) {
    var mproduct_id = product_id + ui.mpsub;
    w.google_tag_params = {dynx_itemid: mproduct_id, dynx_pagetype: 'offerdetail', dynx_totalvalue: product.saleprice};
    dataLayer.push({google_tag_params: google_tag_params, event: 'remarketingTriggered'});
    dataLayer.push({
      event: 'view_item',
      value: product.saleprice,
      items: [{
        id: mproduct_id,
        google_business_vertical: 'retail'
      }]
    });
    if(!navigator.share)
      _('#share').toggleClass('hidden', true);
    if(!product.instock)
      setTimeout(showOffers, 5000);
  }

  if(d.referrer){
    var ref = d.referrer;
    var last = ref.substring(ref.lastIndexOf('/') + 1);
    var names = product_data.category_names;
    var category_ids = Object.keys(names), category_id;
    for(var i = 0; i < category_ids.length; i++) {
      category_id = category_ids[i];
      if(names[category_id][1] === last) {
        ui.category_id_cart = +category_id;
        break;
      }
    }
  }
}

function onLoad(event) {
  addToCartHE = d.getElementById('product-add-to-cart');
  if(addToCartHE) {
    setTimeout(onResizeProduct, 100);
    w.addEventListener('resize', onResizeProduct);
    if(!ui.headerHE)
      ui.headerHE = d.getElementById('header');
    onScrollProduct();
    w.addEventListener('scroll', onScrollProduct);
  }
  $img = _('#product-image');
  $imgBox = $img.parent();
  if(!isTouch)
    $imgBox.on('mouseenter', imageScaleStart).on('mousemove', imageScaleMove).on('mouseout', imageScaleEnd);
  productImages = JSON.parse(_('#product-images').textGet());
  if(isTouch)
    _(d.body).on('touchstart', touchCountStart).on('touchend', touchCountEnd).toggleClass('is-touch', true);

  initSwipers();
}

function initSwipers() {
  if(typeof Swiper === 'undefined') {
    setTimeout(initSwipers, 50);
    return;
  }

  // Init thumbnail gallery Swiper
  var galleryEl = d.querySelector('.bs-gallery-thumbs');
  if(galleryEl) {
    gallerySwiper = new Swiper(galleryEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      watchSlidesProgress: true,
    });
  }

  // Init related products Swipers
  d.querySelectorAll('.bs-related-swiper').forEach(function(el) {
    var wrap = el.parentElement;
    new Swiper(el, {
      slidesPerView: 2,
      spaceBetween: 8,
      freeMode: true,
      navigation: {
        prevEl: wrap ? wrap.querySelector('.swiper-btn-prev') : null,
        nextEl: wrap ? wrap.querySelector('.swiper-btn-next') : null,
      },
      breakpoints: {
        640: { slidesPerView: 3},
        768: { slidesPerView: 4},
        1024: { slidesPerView: 5},
      }
    });
  });

  // Init installment slider(s) — there can be two (mobile + desktop layouts)
  d.querySelectorAll('.bs-installment-swiper').forEach(function(el) {
    var wrap = el.parentElement;
    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: wrap ? wrap.querySelector('.swiper-btn-prev') : null,
        nextEl: wrap ? wrap.querySelector('.swiper-btn-next') : null,
      },
    });
  });
}

function onResizeProduct(event) {
  var isFixed = addToCartHE.classList.contains('product-add-to-cart-fixed');
  if(isFixed)
    addToCartHE.classList.remove('product-add-to-cart-fixed');
  var topOffset = (w.innerWidth > 1024) ? 108 : 52;
  addToCartTop = addToCartHE.getBoundingClientRect().top - d.body.getBoundingClientRect().top - topOffset;
  addToCartLeft = addToCartHE.getBoundingClientRect().left;
  if(isFixed)
    addToCartHE.classList.add('product-add-to-cart-fixed');
}

function onScrollProduct(event) {
  if(!addToCartHE || !ui.headerHE)
    return;
  if (d.documentElement.scrollTop > addToCartTop) {
    addToCartHE.classList.add('product-add-to-cart-fixed');
    addToCartHE.style.left = addToCartLeft + 'px';
    addToCartHE.style.top = ui.headerHE.clientHeight + 'px';
  } else {
    addToCartHE.classList.remove('product-add-to-cart-fixed');
    addToCartHE.style.left = '';
    addToCartHE.style.top = '';
  }
}

function formOnBlur(event) {
  if(!event.target.name)
    return;
  if(event.target.validity.valid)
    event.target.classList.remove('input-error');
  else
    event.target.classList.add('input-error');
}

function formOnInput(event) {
  if(event.target.validity.valid)
    event.target.classList.remove('input-error');
}

function galleryClick(event) {
  var btn = event.target.closest('.product-gallery-item');
  if(!btn)
    return;
  var index = +btn.getAttribute('data-index');
  if(isNaN(index)) return;
  gallerySelectIndex(index);
}

function gallerySelectIndex(index) {
  var items = d.querySelectorAll('.product-gallery-item');
  items.forEach(function(el) {
    var isActive = +el.getAttribute('data-index') === index;
    el.classList.toggle('product-gallery-item-selected', isActive);
    el.classList.toggle('border-\\[\\#FFD600\\]', isActive);
    el.classList.toggle('ring-1', isActive);
    el.classList.toggle('ring-\\[\\#FFD600\\]', isActive);
    el.classList.toggle('border-gray-200', !isActive);
  });
  galleryIndex = index;
  if(!productImages[index]) return;
  var videoHE = d.getElementById('product-video');
  if(productImages[index][0] === 'youtube') {
    $img.el.style.display = 'none';
    if(videoHE) videoHE.remove();
    var iframe = d.createElement('iframe');
    iframe.id = 'product-video';
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.src = 'https://www.youtube.com/embed/' + productImages[index][1] + '?autoplay=1';
    iframe.frameBorder = '0';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.className = 'absolute inset-0 w-full h-full';
    $img.el.parentElement.appendChild(iframe);
  } else {
    if(videoHE) videoHE.remove();
    $img.el.style.display = '';
    $img.attr('src', productImages[index][1]);
  }
}

function productGalleryPrev() {
  if(gallerySwiper) gallerySwiper.slidePrev();
  var newIndex = galleryIndex > 0 ? galleryIndex - 1 : productImages.length - 1;
  gallerySelectIndex(newIndex);
}

function productGalleryNext() {
  if(gallerySwiper) gallerySwiper.slideNext();
  var newIndex = galleryIndex < productImages.length - 1 ? galleryIndex + 1 : 0;
  gallerySelectIndex(newIndex);
}

function imageScaleEnd(event) {
  $img.toggleClass('product-image-hidden', false);
  $imgBox.el.style.backgroundImage = '';
  $imgBox.el.style.backgroundPosition = '';
  imageScaleStarted = false;
}

function imageScaleMove(event) {
  event.preventDefault();
  event.stopPropagation();
  if(!imageScaleStarted)
    imageScaleStart();
  var coord = event.changedTouches ? event.changedTouches[0] : event;
  var x = Math.trunc(100 * (coord.clientX - imgBoxRect.left) / imgBoxRect.width);
  var y = Math.trunc(100 * (coord.clientY - imgBoxRect.top) / imgBoxRect.height);
  $imgBox.el.style.backgroundPosition = x + '% ' + y + '%';
}

function imageScaleStart(event) {
  $img.toggleClass('product-image-hidden', true);
  $imgBox.el.style.backgroundImage = 'url(' + productImages[galleryIndex][0] + ')';
  imgBoxRect = $imgBox.el.getBoundingClientRect();
  imageScaleStarted = true;
}

function imageShow(event) {
  var count = productImages.length;
  var rootHE = d.createElement('div');
  rootHE.className = 'gallery-show-swiper';

  // Counter
  var countHE = rootHE.appendChild(d.createElement('div'));
  countHE.className = 'gallery-show-count';

  // Swiper container
  var swiperHE = rootHE.appendChild(d.createElement('div'));
  swiperHE.className = 'swiper';

  var wrapperHE = swiperHE.appendChild(d.createElement('div'));
  wrapperHE.className = 'swiper-wrapper';

  for(var i = 0; i < count; i++) {
    var slideHE = wrapperHE.appendChild(d.createElement('div'));
    slideHE.className = 'swiper-slide';
    if(productImages[i][0] === 'youtube') {
      var iframe = slideHE.appendChild(d.createElement('iframe'));
      iframe.width = '100%';
      iframe.height = '100%';
      iframe.src = 'https://www.youtube.com/embed/' + productImages[i][1];
      iframe.frameBorder = '0';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%';
      slideHE.style.position = 'relative';
      (function(slide) {
        var overlay = slide.appendChild(d.createElement('div'));
        overlay.style.cssText = 'position:absolute;inset:0;z-index:2;cursor:pointer;background:transparent';
        var startX = 0, startY = 0;
        overlay.addEventListener('touchstart', function(e) {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        }, {passive: true});
        overlay.addEventListener('touchend', function(e) {
          var dx = Math.abs(e.changedTouches[0].clientX - startX);
          var dy = Math.abs(e.changedTouches[0].clientY - startY);
          if(dx < 10 && dy < 10) overlay.style.display = 'none';
        });
        overlay.addEventListener('click', function() { overlay.style.display = 'none'; });
      })(slideHE);
    } else {
      var img = slideHE.appendChild(d.createElement('img'));
      img.src = productImages[i][0];
    }
  }

  // Navigation arrows
  var prevHE = rootHE.appendChild(d.createElement('button'));
  prevHE.className = 'gallery-swiper-prev';
  prevHE.innerHTML = '<svg class="w-4 h-4"><use href="#svg-icon-arrow-left"/></svg>';
  var nextHE = rootHE.appendChild(d.createElement('button'));
  nextHE.className = 'gallery-swiper-next';
  nextHE.innerHTML = '<svg class="w-4 h-4"><use href="#svg-icon-arrow-right"/></svg>';

  function onKeyboardRemove() {
    if(swiperInstance) swiperInstance.destroy(true, true);
    d.removeEventListener('keydown', onKeyboard);
  }

  function onKeyboard(event) {
    if(event.which === 37 && swiperInstance) swiperInstance.slidePrev();
    else if(event.which === 39 && swiperInstance) swiperInstance.slideNext();
  }

  ui.modalOpenHE(rootHE, '', true, true, onKeyboardRemove);

  var swiperInstance = new Swiper(swiperHE, {
    initialSlide: galleryIndex,
    slidesPerView: 1,
    spaceBetween: 8,
    loop: count > 1,
    navigation: {
      prevEl: prevHE,
      nextEl: nextHE
    },
    on: {
      slideChange: function() {
        countHE.innerHTML = (this.realIndex + 1) + ' / ' + count;
      }
    }
  });

  countHE.innerHTML = (galleryIndex + 1) + ' / ' + count;
  d.addEventListener('keydown', onKeyboard, false);
}

function ratingChange(event) {
  event.preventDefault();
  var he = event.target;
  if(he.tagName === 'path')
    he = he.parentElement;
  var rating = he.getAttribute('data');
  if(rating === null)
    return;
  var children = event.currentTarget.children, rating2;
  for(var i = 0; i < children.length; i++) {
    he = children[i];
    if(he.name)
      he.value = rating;
    else {
      rating2 = he.getAttribute('data');
      if(rating2 === null)
        continue;
      if(rating2 <= rating) {
        he.classList.add('text-yellow-400');
        he.classList.remove('text-gray-200');
        he.querySelector('use').setAttribute('href', '#svg-icon-star-fill');
      } else {
        he.classList.remove('text-yellow-400');
        he.classList.add('text-gray-200');
        he.querySelector('use').setAttribute('href', '#svg-icon-star');
      }
    }
  }
}

function reviewStarSVG(i) {
  var svg = d.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', '24');
  svg.setAttribute('height', '24');
  svg.setAttribute('class', 'w-10 h-10 transition-colors drop-shadow-sm cursor-pointer text-yellow-400');
  svg.setAttribute('data', i);
  var use = d.createElementNS('http://www.w3.org/2000/svg', 'use');
  use.setAttribute('href', '#svg-icon-star-fill');
  svg.appendChild(use);
  return svg;
}

function reviewAdd(event) {
  event.preventDefault();
  var starContainer = _('div').attr('class', 'flex justify-center gap-2', 'onclick', 'ui.ratingChange(event)');
  var ratingInput = _('input').attr('type', 'hidden', 'name', 'rating', 'value', 5);
  starContainer.el.appendChild(ratingInput.el);
  for(var i = 1; i <= 5; i++)
    starContainer.el.appendChild(reviewStarSVG(i));

  var he = _('div').append(
    _('form').attr('class', 'review-form', 'oninput', 'ui.formOnInput(event)', 'onfocusout', 'ui.formOnBlur(event)').append(
      _('input').attr('type', 'hidden', 'name', 'product_id', 'value', product.product_id),
      _('div').attr('class', 'p-6 overflow-y-auto space-y-6 text-sm').append(
        _('div').attr('class', 'text-center py-2').append(
          _('p').attr('class', 'font-bold text-gray-900 mb-3 text-base').text(ui.lang.text_rating),
          starContainer
        ),
        _('div').attr('class', 'grid grid-cols-2 gap-6').append(
          _('div').attr('class', 'col-span-2 md:col-span-1').append(
            _('label').attr('class', 'block text-xs font-bold text-gray-700 mb-1.5 uppercase tracking-wide').html(ui.lang.text_name + ' <span class="text-red-500">*</span>'),
            _('input').attr('type', 'text', 'name', 'name', 'required', 'true', 'minlength', '3', 'maxlength', '50', 'class', 'w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent transition-all text-sm placeholder:text-gray-400')
          ),
          _('div').attr('class', 'col-span-2 md:col-span-1').append(
            _('label').attr('class', 'block text-xs font-bold text-gray-700 mb-1.5 uppercase tracking-wide').text(ui.lang.text_email),
            _('input').attr('type', 'email', 'name', 'email', 'required', 'true', 'minlength', '3', 'maxlength', '50', 'class', 'w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent transition-all text-sm placeholder:text-gray-400')
          ),
          _('div').attr('class', 'col-span-2').append(
            _('label').attr('class', 'block text-xs font-bold text-gray-700 mb-1.5 uppercase tracking-wide').text(ui.lang.text_telephone),
            _('input').attr('type', 'tel', 'name', 'telephone', 'placeholder', '0XXXXXXXXX', 'required', 'true', 'minlength', '10', 'maxlength', '10', 'class', 'w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent transition-all text-sm placeholder:text-gray-400')
          )
        ),
        _('div').append(
          _('label').attr('class', 'block text-xs font-bold text-gray-700 mb-1.5 uppercase tracking-wide').html(ui.lang.text_comment + ' <span class="text-red-500">*</span>'),
          _('textarea').attr('name', 'text', 'rows', '4', 'required', 'true', 'minlength', '25', 'maxlength', '1000', 'class', 'w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent transition-all text-sm resize-none placeholder:text-gray-400')
        )
      ),
      _('div').attr('class', 'p-5 border-t border-gray-100 bg-gray-50 flex justify-end gap-3').append(
        _('button').attr('type', 'button', 'class', 'h-11 px-6 text-sm font-bold uppercase tracking-wide border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 rounded-md', 'onclick', 'ui.modalClose()').text(ui.lang.text_close),
        _('button').attr('type', 'button', 'class', 'h-11 px-8 text-sm font-bold uppercase tracking-wide bg-brand text-brand-text rounded-md shadow-md active:scale-95 transition-transform', 'onclick', 'ui.postData(event, ui.url.reviewAdd)').text(ui.lang.text_write)
      )
    )
  );
  ui.modalOpenHE(he, ui.lang.text_review_add);
}

function shareModal() {
  if(navigator.share) {
    navigator.share({
      title: d.title,
      text: d.title,
      url: location.href
    });
  }
}

function showOffers() {
  function init() {
    function add(index) {
      if(category_products.length === 0)
        return;
      to_show.push(category_products[index]);
      category_products.splice(index, 1);
    }

    var category_id = product.category_ids[product.category_ids.length - 1];
    var product_ids = Object.keys(product_data.products), product_id, p;
    var popular, popular_index = -1;
    var category_products = [], to_show = [];
    for(var i = 0; i < product_ids.length; i++) {
      product_id = product_ids[i];
      p = ui.productGet(product_id, true);
      if(p.instock && (p.category_ids.indexOf(category_id) !== -1)) {
        if(!popular || (popular.popularity < p.popularity)) {
          popular = p;
          popular_index = category_products.length;
        }
        category_products.push(p);
      }
    }
    add(popular_index);
    category_products.sort(function(a, b) {
      return a.saleprice - b.saleprice;
    });
    add(category_products.length >> 1);
    add(category_products.length - 1);
    add(0);
    return to_show;
  }

  var products = init();
  if(products.length === 0)
    return;

  var L = ui.lang;
  var SVG_X = '<svg class="w-6 h-6 text-neutral-400 group-hover:rotate-90 transition-transform" aria-hidden="true"><use href="#svg-icon-x"/></svg>';
  var SVG_CART = '<svg width="16" height="16" aria-hidden="true"><use href="#svg-icon-cart-solid"/></svg>';

  var rows = '';
  for(var i = 0; i < products.length; i++) {
    var p = products[i];
    rows +=
      '<div class="offers-product">' +
        '<img class="offers-product-img" src="' + p.image + '" alt="">' +
        '<div class="offers-product-info">' +
          '<a class="offers-product-title" href="' + p.href + '">' + p.title + '</a>' +
          '<div class="offers-product-prices">' +
            '<span class="offers-product-price">' + ui.priceFormat(p.saleprice) + '</span>' +
            (p.price_old ? '<span class="offers-product-price-old">' + ui.priceFormat(p.price_old) + '</span>' : '') +
          '</div>' +
        '</div>' +
        '<span class="flex flex-shrink-0" data-cart-btn="' + p.product_id + '">' +
          '<button type="button" aria-label="Buy" class="cart-add-only w-9 h-9 bg-brand hover:bg-brand-hover text-brand-text rounded-xl flex items-center justify-center shadow-sm border-0 cursor-pointer" onclick="ui.cartUI.add(event, ' + p.product_id + ')">' + SVG_CART + '</button>' +
          '<button type="button" aria-label="In cart" class="cart-in-cart-only !hidden w-9 h-9 cart-mini-incart rounded-xl flex items-center justify-center shadow-sm border-0 cursor-pointer" onclick="ui.cartUI.update(true)">' + SVG_CART + '</button>' +
        '</span>' +
      '</div>';
  }

  var html =
    '<div class="offers-modal-card relative">' +
      '<button type="button" onclick="ui.modalClose()" aria-label="Close" class="absolute top-5 right-5 p-2 hover:bg-neutral-800 hover:text-white rounded-full transition-all z-20 group bg-transparent border-0 cursor-pointer">' + SVG_X + '</button>' +
      '<div class="bg-neutral-900 p-8 text-white relative overflow-hidden border-b-4 border-brand">' +
        '<div class="absolute -right-10 -top-10 w-40 h-40 bg-brand rounded-full blur-3xl opacity-10"></div>' +
        '<h2 class="text-2xl font-black leading-tight tracking-tight uppercase italic m-0">' + L.text_offers_title + '</h2>' +
        '<p class="mt-3 text-neutral-400 text-sm max-w-md mb-0">' + L.text_offers_text + '</p>' +
      '</div>' +
      '<div class="p-8">' +
        '<div class="offers-product-list">' + rows + '</div>' +
      '</div>' +
    '</div>';

  var $wrap = _('div').html(html);
  ui.modalOpenHE(_($wrap.el.firstChild), '');
  if(ui.cartUI && ui.cartUI.update)
    ui.cartUI.update(false);
}

function touchCountEnd(event) {
  touchCount--;
}

function touchCountStart(event) {
  touchCount++;
}

function youtubeShow(event, youtube) {
  event.preventDefault();
  event.stopPropagation();
  var he = _('div').attr('class', 'youtube-modal-content').append(
    _('iframe').attr(
      'allow', 'autoplay; fullscreen',
      'allowfullscreen', true,
      'frameborder', 0,
      'src', 'https://www.youtube.com/embed/' + youtube + '?autoplay=1'
    )
  );
  ui.modalOpenHE(he, '', true, true);
}

})();

(function() {

var _ = ui._;
ui.reviewsShow = reviewsShow;
ui.tabChange = change;

function change(event) {
  var $tabs = _(event.currentTarget);
  var $tab = _(event.target);
  var nameActive = $tabs.attrGet('data-tab');
  var name = $tab.attrGet('data-tab');
  if(!name || name === nameActive)
    return;
  _('#tab-' + nameActive).toggleClass('hidden', true);
  _('#tab-' + name).toggleClass('hidden', false);
  tabSetActive($tab, true);
  for(var i = 0; i < $tabs.el.children.length; i++) {
    var $child = _($tabs.el.children[i]);
    if($child.attrGet('data-tab') === nameActive) {
      tabSetActive($child, false);
      break;
    }
  }
  $tabs.attr('data-tab', name);
  if($tabs.el.getBoundingClientRect().top > w.innerHeight / 2)
    w.scroll({top: $tabs.el.getBoundingClientRect().top + w.pageYOffset - 100, behavior: 'smooth'});
}

function tabSetActive($tab, active) {
  $tab.toggleClass('tab-header-active', active);
  $tab.toggleClass('border-\\[\\#FFD600\\]', active);
  $tab.toggleClass('text-black', active);
  $tab.toggleClass('border-transparent', !active);
  $tab.toggleClass('text-gray-500', !active);
}

function reviewsShow() {
  _('#tab-reviews-header').el.click();
}

// Show sticky bottom bar after scrolling past hero section
d.addEventListener('DOMContentLoaded', function() {
  var hero = d.getElementById('product-hero');
  var bar = d.getElementById('sticky-bottom-bar');
  if(!hero || !bar) return;
  var observer = new IntersectionObserver(function(entries) {
    var visible = !entries[0].isIntersecting;
    bar.classList.toggle('translate-y-full', !visible);
    bar.classList.toggle('translate-y-0', visible);
  }, { threshold: 0 });
  observer.observe(hero);
});

})();